<template>
  <div class="login-wrap" :style="loginWrapStyle">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
      class="demo-ruleForm login-container">
      <div class="system-name">Field Manage System</div>
      <el-divider></el-divider>
      <el-form-item prop="username">
        <el-select v-model="ruleForm.countryNum" placeholder="请选择" style="width: 120px;">
          <el-option v-for="item in allCountries" :key="item.countryNum" :label="item.countryName"
            :value="item.countryNum">
          </el-option>
        </el-select>
        <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="username"
          style="width: 226px;"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="password"></el-input>
      </el-form-item>
      <el-checkbox class="remember" v-model="rememberpwd">remember me</el-checkbox>
      <el-form-item style="width: 100%">
        <el-button type="primary" style="width: 100%" @click="submitForm()" :loading="logining">Log
          In</el-button>
      </el-form-item>
    </el-form>
    <footer>
      <small>&copy; 2022 XGEOMATICS Co., Ltd. All Rights Reserved. </small>
    </footer>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from "../api/userMG";
import { setCookie, getCookie, delCookie } from "../utils/util";
import JSEncrypt from 'jsencrypt'
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

// import md5 from "js-md5";
export default {
  name: "login",
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      allCountries: [],
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
        countryNum: "",
        icc: "",
        code: "",
      },
      //rules前端验证
      rules: {
        username: [
          { required: true, message: "please input username", trigger: "blur" },
        ],
        password: [
          { required: true, message: "please input password", trigger: "blur" },
        ],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loginWrapStyle: {
        backgroundImage: "url(" + require("../assets/img/background.jpg") + ")",
        backgroundRepeat: "no-repeat",
      },
      publicKey:
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAt/EF4566/CEotcHTa4Bj8RLgPUrRJehyOv9+JSAdOo3yXLGn02KHWhCoIzerOO7AIQ05TWgfBH4dXI5G+9qxH6zYms77rW42HKtO1NR83y7EUmW5oJuc0Gb99IfWIij6PJdUFixwctEPrlCH+NSIsOE9t9J+Bo1a67VaAm2jrgWvS6JS3gAJofK/Je5ACtx30Er6qpFVO/s0whc4Cgr9TSD8CkAbP7yjdaBPFzDm6EiEw0IwJ8yr6/9Etyh8zN5FGhnNaIJs4kKNSfQS8tVe0Cbt50sKw7K+V/PzldgiOZGKOVKdO6fm7rVLbIl5I7XBIa4Lky9Os4p6hhcn8WEhKwIDAQAB",
    };
  },

  // 创建完毕状态(里面是操作)
  created() {
    this.loadCookie();

    const phoneUtil = PhoneNumberUtil.getInstance();
    this.allCountries = phoneUtil.getSupportedRegions().map((countryNum) => {
      const countryName = new Intl.DisplayNames(['en'], { type: 'region' }).of(countryNum)
      return { countryNum, countryName };
    }).sort((a, b) => a.countryName > b.countryName ? 1 : -1);
    this.ruleForm.countryNum = "CN";

  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    loadCookie() {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.ruleForm.username = getCookie("user");
        this.ruleForm.password = getCookie("pwd");
        this.ruleForm.countryNum = getCookie("countryNum");
        this.rememberpwd = true;
      }
    },
    //获取info列表
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.logining = true;
          let username = this.ruleForm.username;
          let password = this.ruleForm.password;
          let countryNum = this.ruleForm.countryNum;

          var encrypt = new JSEncrypt();
          encrypt.setPublicKey(this.publicKey);
          this.ruleForm.password = encrypt.encrypt(this.ruleForm.password.toString());

          this.ruleForm.icc = PhoneNumberUtil.getInstance().parse(username, countryNum).getCountryCode();


          login(this.ruleForm)
            .then((res) => {
              if (res.status == 200) {
                if (this.rememberpwd) {
                  //保存到cookie，有效期7天
                  setCookie("user", username, 7);
                  setCookie("pwd", password, 7);
                  setCookie("countryNum", countryNum, 7);
                } else {
                  delCookie("user");
                  delCookie("pwd");
                  delCookie("countryNum");
                }
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.logining = false;
                  // 缓存token
                  localStorage.setItem("logintoken", res.result.access_token);
                  // 缓存用户个人信息
                  localStorage.setItem("userdata", JSON.stringify(res.result));
                  localStorage.setItem("userId", res.result.id);
                  localStorage.setItem("userUid", res.result.guid);
                  localStorage.setItem("userName", res.result.name);
                  this.$store.commit("login", "true");
                  this.$router.push({ path: "/map/map" });
                }, 1000);
              } else {
                this.$message.error(res.message);
                this.logining = false;
                return false;
              }
            })
            .catch((e) => {
              this.logining = false;
              this.$message.error(e);
            });
        } else {
          this.$message.error("Username or password error!");
          this.logining = false;
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 12%;
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center right;
  /* background-size: 100%; */
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

footer {
  color: white;
  width: 100%;
  height: 20px;
  position: absolute;
  bottom: 0px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.5);
}

.system-name {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue